/*
  HYA accessibility runtime patches — Level Access / WCAG 2.2 AA findings.
  Fixes markup that comes from apps (Judge.me, LimeSpot, Loox, Klaviyo, Google
  Customer Reviews, chat widgets) and from page/blog/product content that can't
  be fixed in theme Liquid. Idempotent; re-runs on DOM changes.
  Config: window.HYA_A11Y = { hosts: [...], canonicalProductUrls: bool, horizonBackgrounds: bool }
*/
(function () {
  'use strict';
  var CFG = window.HYA_A11Y || {};
  var HOSTS = (CFG.hosts || []).map(function (h) { return h.toLowerCase(); });
  var TRACKING = ['lshst', 'lssrc', 'lsbundle', '_pos', '_sid', '_ss', '_psq', '_fid', 'pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq'];
  var GENERIC = /^(learn more|shop now|shop|read more\.*|more info|more|here|click here|faq|faqs|view all|buy now|see more|see all|details|read on|continue reading|s)$/i;
  var uid = 0;

  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isInternal(host) { host = (host || '').toLowerCase(); return HOSTS.indexOf(host) > -1 || /\.myshopify\.com$/.test(host) || /\.shopifypreview\.com$/.test(host); }
  function visible(el) { if (!el) return false; var cs = getComputedStyle(el); return cs.display !== 'none' && cs.visibility !== 'hidden'; }

  /* Accessible-name approximation for links / buttons */
  function accName(el) {
    if (el.getAttribute('aria-label')) return el.getAttribute('aria-label').trim();
    var lb = el.getAttribute('aria-labelledby');
    if (lb) { var parts = lb.split(/\s+/).map(function (id) { var t = document.getElementById(id); return t ? txt(t) : ''; }).join(' ').trim(); if (parts) return parts; }
    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('[aria-hidden="true"]'), function (n) { n.parentNode && n.parentNode.removeChild(n); });
    var t = txt(clone);
    if (t) return t;
    var img = el.querySelector('img[alt], svg[aria-label], [aria-label]');
    if (img) return (img.getAttribute('alt') || img.getAttribute('aria-label') || '').trim();
    var title = el.querySelector('svg title');
    if (title) return txt(title);
    return (el.getAttribute('title') || '').trim();
  }
  function slugToWords(url) {
    try { var p = new URL(url, location.href).pathname.split('/').filter(Boolean).pop() || ''; p = decodeURIComponent(p).replace(/[-_]+/g, ' ').replace(/\.\w+$/, '').trim(); return p ? p.charAt(0).toUpperCase() + p.slice(1) : ''; } catch (e) { return ''; }
  }
  function targetWords(href) {
    var path = ''; try { path = new URL(href, location.href).pathname; } catch (e) { return slugToWords(href); }
    if (/^\/collections\/all\/?$/.test(path)) return 'All products';
    if (/^\/collections\/[^/]+\/?$/.test(path)) return slugToWords(path) + ' collection';
    if (/^\/pages\/[^/]+\/?$/.test(path)) return slugToWords(path) + ' page';
    return slugToWords(path);
  }
  function contextHeading(el) {
    /* nearest ancestor that contains a heading; prefer the closest heading before the link */
    var node = el.parentElement, depth = 0;
    while (node && node !== document.body && depth < 10) {
      var hs = node.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"], .h1, .h2, .h3, .h4, .h5, .h6, [class*="__heading"], [class*="__title"], [class*="-title"], .title, strong');
      var before = null, after = null;
      for (var i = 0; i < hs.length; i++) {
        if (hs[i].contains(el) || !txt(hs[i])) continue;
        if (hs[i].compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) before = hs[i]; else if (!after) after = hs[i];
      }
      if (before || after) return txt(before || after).slice(0, 80);
      if (/^(SECTION|ARTICLE|MAIN|FOOTER|HEADER)$/.test(node.tagName) || node.classList.contains('shopify-section')) break;
      node = node.parentElement; depth++;
    }
    return '';
  }

  /* Sentence around an inline link ("Care instructions can be found here") */
  function sentenceContext(a) {
    var p = a.parentElement; if (!p || !/^(P|LI|SPAN|TD|DIV|EM|STRONG|B|I|FONT)$/.test(p.tagName)) return '';
    if (p.querySelectorAll('a').length > 3) return '';
    var clone = p.cloneNode(true); Array.prototype.forEach.call(clone.querySelectorAll('a'), function (n) { n.parentNode.removeChild(n); });
    var t = txt(clone).replace(/^[\s:,.;–-]+|[\s:,.;–-]+$/g, '');
    return (t.length >= 3 && t.length <= 120) ? t : '';
  }

  /* 1. Links: canonical internal URLs, strip tracking params */
  function normalizeLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      var raw = a.getAttribute('href'); if (!raw) return;
      if (/^tel:/i.test(raw)) { var digits = raw.slice(4).replace(/[^\d+]/g, ''); if (digits && 'tel:' + digits !== raw) a.setAttribute('href', 'tel:' + digits); return; }
      if (/^(#|mailto:|javascript:)/i.test(raw)) return;
      var url; try { url = new URL(raw, location.href); } catch (e) { return; }
      var internal = isInternal(url.hostname) || url.hostname === location.hostname;
      if (!internal) return;
      var changed = false;
      TRACKING.forEach(function (k) { if (url.searchParams.has(k)) { url.searchParams.delete(k); changed = true; } });
      var path = url.pathname;
      if (CFG.canonicalProductUrls) { var m = path.match(/^\/collections\/[^/]+(\/products\/[^/]+)\/?$/); if (m) { path = m[1]; changed = true; } }
      var rel = path + (url.search && url.search !== '?' ? url.search : '') + url.hash;
      if (changed || /^https?:/i.test(raw)) { if (rel !== raw) a.setAttribute('href', rel); }
    });
  }

  /* 2. Links whose name is generic ("Learn more", "here", "FAQ") or empty */
  function labelLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      if (a.hasAttribute('aria-label') || a.hasAttribute('aria-labelledby')) return;
      var name = accName(a);
      var href = a.getAttribute('href') || '';
      if (!name) {
        if (/\/cart\b/.test(href) || a.querySelector('.cart_count, .cart-count')) { a.setAttribute('aria-label', 'Cart'); return; }
        if (/\/account\b|login/i.test(href) || /account|login|user/i.test(a.className)) { a.setAttribute('aria-label', 'Account'); return; }
        if (/search/i.test(href + ' ' + a.className)) { a.setAttribute('aria-label', 'Search'); return; }
        var social = href.match(/(facebook|instagram|twitter|x\.com|pinterest|youtube|tiktok|linkedin|snapchat|vimeo)/i);
        if (social) { var n = social[1].replace('x.com', 'X').replace(/^\w/, function (c) { return c.toUpperCase(); }); a.setAttribute('aria-label', n); return; }
        if (/close/i.test(a.className)) { a.setAttribute('aria-label', 'Close'); return; }
        if (/loox-pn-branding|powered|branding/i.test(a.className)) { a.setAttribute('aria-label', 'Powered by Loox'); return; }
        if (href === '/' || /^https?:\/\/[^/]+\/?$/.test(href)) { a.setAttribute('aria-label', 'Home'); return; }
        var ctx = (a.getAttribute('title') || '') || contextHeading(a) || slugToWords(href);
        if (ctx) a.setAttribute('aria-label', ctx); else { a.setAttribute('aria-hidden', 'true'); a.setAttribute('tabindex', '-1'); }
        return;
      }
      if (/^\d+$/.test(name) && (/\/cart\b/.test(href) || a.querySelector('.cart_count, .cart-count'))) { a.setAttribute('aria-label', 'Cart, ' + name + ' items'); return; }
      if (/^mailto:/i.test(href) && name.indexOf('@') === -1) { var addr = href.replace(/^mailto:/i, '').replace(/%20/g, '').split('?')[0].trim(); if (addr) a.setAttribute('aria-label', name + ' – email ' + addr); return; }
      if (/^tel:/i.test(href) && !/\d{3}/.test(name)) { var num = href.replace(/^tel:/i, '').replace(/%20/g, ' ').trim(); if (num) a.setAttribute('aria-label', name + ' – call ' + num); return; }
      if (GENERIC.test(name)) {
        var t = (a.getAttribute('title') || '').trim();
        var ctx2 = (t && t.toLowerCase() !== name.toLowerCase()) ? t : sentenceContext(a) || contextHeading(a);
        if (!ctx2 && /^faqs?$/i.test(name)) ctx2 = 'Frequently asked questions';
        if (!ctx2 || ctx2.toLowerCase() === name.toLowerCase()) ctx2 = targetWords(href);
        if (ctx2 && ctx2.toLowerCase() !== name.toLowerCase()) a.setAttribute('aria-label', name + ' – ' + ctx2);
      }
    });
  }

  /* 2b. Same link text, different destinations: add the destination to the name */
  function dedupeLinks() {
    var groups = {};
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      if (a.__hyaDedup || a.closest('.jdgm-rev, .jdgm-widget')) return;
      var n = accName(a).toLowerCase(); if (!n || n.length > 60) return;
      var href = (a.getAttribute('href') || '').split('#')[0]; if (!href || /^(javascript:|mailto:|tel:)/i.test(href)) return;
      try { var u = new URL(href, location.href); href = (isInternal(u.hostname) || u.hostname === location.hostname) ? u.pathname + u.search : u.href; } catch (e) { return; }
      groups[n] = groups[n] || {}; (groups[n][href] = groups[n][href] || []).push(a);
    });
    Object.keys(groups).forEach(function (n) {
      var hrefs = Object.keys(groups[n]); if (hrefs.length < 2) return;
      hrefs.sort(function (x, y) { return groups[n][y].length - groups[n][x].length; });
      hrefs.slice(1).forEach(function (h) {
        var words = targetWords(h); if (!words || words.toLowerCase() === n) return;
        groups[n][h].forEach(function (a) { a.__hyaDedup = true; a.setAttribute('aria-label', accName(a) + ' – ' + words); });
      });
    });
  }

  /* 3. Anchors without href */
  function fixHrefless() {
    Array.prototype.forEach.call(document.querySelectorAll('a:not([href])'), function (a) {
      if (a.closest('svg')) return;
      var t = txt(a);
      if (/^[\w.+-]+@[\w-]+\.[\w.-]+$/.test(t)) { a.setAttribute('href', 'mailto:' + t); return; }
      var interactive = a.hasAttribute('onclick') || a.getAttribute('role') === 'button' || /btn|button|toggle|load-more|paginate|trigger|open|close/i.test(a.className);
      if (interactive) { a.setAttribute('role', 'button'); if (!a.hasAttribute('tabindex')) a.setAttribute('tabindex', '0'); addKey(a); return; }
      if (!t && !a.children.length) { if (a.id || a.getAttribute('name')) { var s = document.createElement('span'); if (a.id) s.id = a.id; a.parentNode.replaceChild(s, a); } else a.parentNode.removeChild(a); return; }
      var span = document.createElement('span'); span.className = a.className; span.innerHTML = a.innerHTML; a.parentNode.replaceChild(span, a);
    });
  }
  function addKey(el) {
    if (el.__hyaKey) return; el.__hyaKey = true;
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } });
  }

  /* 4. Click-only elements */
  function fixClickOnly() {
    Array.prototype.forEach.call(document.querySelectorAll('div[onclick], span[onclick], li[onclick], img[onclick]'), function (el) {
      if (el.closest('button, [role="button"]') && el.closest('button, [role="button"]') !== el) return;
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      addKey(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[tabindex]'), function (el) {
      if (el.tabIndex < 0 || el.getAttribute('role')) return;
      if (/^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY|IFRAME|VIDEO|AUDIO|DIALOG|DETAILS)$/.test(el.tagName)) return;
      if (el.matches('[data-predictive-search], .cart-notification, .search-modal__content, .drawer__inner, .menu-drawer__inner-container, dialog, [aria-modal]')) return;
      el.setAttribute('role', 'group');
    });
  }

  /* 5. Images, SVGs, iframes */
  function fixMedia() {
    Array.prototype.forEach.call(document.querySelectorAll('img:not([alt])'), function (img) {
      var link = img.closest('a[href]');
      if (link && !txt(link) && !link.getAttribute('aria-label')) { img.setAttribute('alt', contextHeading(link) || slugToWords(link.getAttribute('href')) || ''); }
      else img.setAttribute('alt', '');
    });
    /* an image inside a link/button that already has visible text is decorative */
    Array.prototype.forEach.call(document.querySelectorAll('a img[alt], button img[alt]'), function (img) {
      if (!img.getAttribute('alt').trim()) return;
      var ctl = img.closest('a, button'); var clone = ctl.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('img, svg'), function (n) { n.parentNode.removeChild(n); });
      if (txt(clone).length > 1) img.setAttribute('alt', '');
    });
    Array.prototype.forEach.call(document.querySelectorAll('svg'), function (s) {
      if (s.getAttribute('aria-hidden') || s.getAttribute('aria-label') || s.getAttribute('aria-labelledby') || s.getAttribute('role') === 'img' || s.querySelector('title')) return;
      var ctl = s.closest('a, button, summary, label, [role="button"], [role="link"]');
      if (ctl && (accName(ctl) || ctl.getAttribute('aria-label'))) { s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); return; }
      s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('iframe'), function (f) {
      if (!f.getAttribute('title') && !f.getAttribute('aria-label')) {
        var src = (f.getAttribute('src') || '') + ' ' + (f.id || '') + ' ' + (f.className || '');
        var name = /youtube|youtu\.be|vimeo|wistia/i.test(src) ? 'Video player' : /loox/i.test(src) ? 'Customer reviews' : /merchantwidget|customerreviews|google/i.test(src) ? 'Google Customer Reviews badge' : /klaviyo/i.test(src) ? 'Newsletter signup' : /recaptcha/i.test(src) ? 'reCAPTCHA' : /instagram|instafeed/i.test(src) ? 'Instagram feed' : /judge|jdgm/i.test(src) ? 'Reviews' : /chat|tidio|gorgias|zendesk|intercom/i.test(src) ? 'Chat' : 'Embedded content';
        f.setAttribute('title', name);
      }
      var h = f.getAttribute('height');
      if (h && /^\d+(px)?$/.test(h) && !f.style.height) { f.style.height = parseInt(h, 10) + 'px'; f.removeAttribute('height'); }
    });
  }

  /* 6. Form controls without names */
  function labelFor(input) {
    if (input.id) { var l = document.querySelector('label[for="' + CSS.escape(input.id) + '"]'); if (l && txt(l)) return txt(l); }
    var wrap = input.closest('label'); if (wrap && txt(wrap)) return txt(wrap);
    return '';
  }
  function fixForms() {
    Array.prototype.forEach.call(document.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="image"]), textarea, select'), function (el) {
      var type = (el.getAttribute('type') || el.tagName).toLowerCase();
      var al = el.getAttribute('aria-label');
      if (al && (type === 'radio' || type === 'checkbox') && (al.trim().length < 4 || /^[\d"'.]+$/.test(al.trim()))) {
        var fs0 = el.closest('fieldset'); var lg0 = fs0 && fs0.querySelector('legend');
        var opt0 = lg0 ? txt(lg0).replace(/:.*$/, '').trim() : (el.getAttribute('name') || '').replace(/:.*$/, '').replace(/[-_]/g, ' ').trim();
        if (opt0 && al.toLowerCase().indexOf(opt0.toLowerCase()) === -1) el.setAttribute('aria-label', opt0 + ': ' + al.trim());
        return;
      }
      if (al || el.getAttribute('aria-labelledby') || el.getAttribute('title')) return;
      var lbl = labelFor(el);
      if (type === 'radio' || type === 'checkbox') {
        var fs = el.closest('fieldset'); var legend = fs && fs.querySelector('legend');
        var opt = legend ? txt(legend).replace(/:.*$/, '').replace(/\s*\(.*\)\s*$/, '') : (el.getAttribute('name') || '').replace(/:.*$/, '').replace(/[-_]/g, ' ').trim();
        var val = lbl || el.value || '';
        if (/^(on|true|1)$/i.test(val)) val = '';
        if (!lbl) { var near = ''; var anc = el.parentElement; for (var i = 0; i < 4 && anc && !near; i++) { if (/^(FORM|SECTION|MAIN|BODY)$/.test(anc.tagName)) break; var tt = anc.querySelector('a, h2, h3, h4, [class*="title"], [class*="name"]'); near = ((tt && txt(tt)) || txt(anc)).slice(0, 80); anc = anc.parentElement; } if (near) val = (/bundle/i.test(el.className) ? 'Include in bundle: ' : '') + near; }
        if (!val) return;
        if (opt && val.toLowerCase().indexOf(opt.toLowerCase()) === -1 && (!lbl || val.length < 4 || /^[\d"'.]+$/.test(val))) el.setAttribute('aria-label', opt + ': ' + val);
        else if (!lbl) el.setAttribute('aria-label', val);
        return;
      }
      if (lbl) return;
      var ph = el.getAttribute('placeholder');
      if (ph) { el.setAttribute('aria-label', ph.replace(/\.{2,}$/, '').trim()); return; }
      if (type === 'search' || el.name === 'q') { el.setAttribute('aria-label', 'Search'); return; }
      if (type === 'select') {
        var cand = [el.previousElementSibling, el.parentElement && el.parentElement.previousElementSibling, el.parentElement && el.parentElement.querySelector('label, .label, .select_label, .option_label')];
        var pt = '';
        for (var ci = 0; ci < cand.length && !pt; ci++) { var cn = cand[ci]; if (cn && cn !== el && !cn.contains(el) && /^(LABEL|SPAN|P|DIV|H\d|STRONG|B|LEGEND)$/.test(cn.tagName)) { var ct = txt(cn); if (ct && ct.length < 60) pt = ct; } }
        el.setAttribute('aria-label', pt || 'Select an option'); return;
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('button, input[type="submit"], input[type="button"]'), function (b) {
      var cur = (b.getAttribute('aria-label') || '').trim();
      if (/quick-add__button|add-to-cart/.test(b.className) && (!cur || /^(cart|add|choose|add to cart|choose options)$/i.test(cur))) {
        var ctxq = contextHeading(b); var verb = /choose/i.test(cur + ' ' + txt(b)) ? 'Choose options' : 'Add to cart';
        b.setAttribute('aria-label', verb + (ctxq ? ' – ' + ctxq : '')); return;
      }
      if (cur || b.getAttribute('aria-labelledby')) return;
      var name = accName(b) || (b.value || '').trim();
      if (!name) { if (/search/i.test(b.className + ' ' + (b.name || '') + ' ' + (b.form && b.form.getAttribute('action') || ''))) b.setAttribute('aria-label', 'Search'); else if (/close|dismiss/i.test(b.className)) b.setAttribute('aria-label', 'Close'); else if (/menu|hamburger|nav/i.test(b.className)) b.setAttribute('aria-label', 'Menu'); else if (/cart/i.test(b.className)) b.setAttribute('aria-label', 'Cart'); return; }
      if (/^add$/i.test(name)) { var ctx = contextHeading(b); b.setAttribute('aria-label', 'Add to cart' + (ctx ? ' – ' + ctx : '')); return; }
      if (/^more$/i.test(name)) { b.setAttribute('aria-label', b.closest('nav, [class*="menu"]') ? 'More menu items' : 'More options'); return; }
      if (b.classList.contains('variant-pill') || /^[\d.]+"?$/.test(name)) { var fs = b.closest('fieldset, .option, .option-group, .swatch, [data-option]'); var lg = fs && (fs.querySelector('legend, .option-title, .label, h4, h5') ); var on = b.getAttribute('data-option') || (lg ? txt(lg) : ''); if (on) b.setAttribute('aria-label', on + ': ' + name); }
    });
  }

  /* 7. Lists */
  function fixLists() {
    Array.prototype.forEach.call(document.querySelectorAll('li'), function (li) {
      var p = li.parentElement; if (!p || /^(UL|OL|MENU)$/.test(p.tagName) || p.getAttribute('role') === 'list') return;
      var ul = document.createElement('ul'); p.insertBefore(ul, li);
      var n = li; while (n && n.tagName === 'LI') { var next = n.nextElementSibling; ul.appendChild(n); n = next; }
    });
    Array.prototype.forEach.call(document.querySelectorAll('ul > ul, ol > ul, ul > ol, ol > ol'), function (nested) {
      var prev = nested.previousElementSibling;
      if (prev && prev.tagName === 'LI') prev.appendChild(nested); else { var li = document.createElement('li'); nested.parentNode.insertBefore(li, nested); li.appendChild(nested); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('ul, ol'), function (list) {
      if (list.getAttribute('role') && list.getAttribute('role') !== 'list') return;
      Array.prototype.forEach.call(Array.prototype.slice.call(list.children), function (c) {
        if (/^(LI|SCRIPT|TEMPLATE)$/.test(c.tagName)) return;
        if (c.tagName === 'STYLE' || c.tagName === 'LINK') { c.parentNode.removeChild(c); document.head.appendChild(c); return; }
        var li = document.createElement('li'); list.insertBefore(li, c); li.appendChild(c);
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('ul > li[role="presentation"], ol > li[role="presentation"], ul > li[role="none"], ol > li[role="none"]'), function (li) { if (!li.closest('[role="menu"], [role="menubar"], [role="tablist"]')) li.removeAttribute('role'); });
  }

  /* 7b. Layout tables (no header cells, block content or a single row/column) */
  function fixTables() {
    Array.prototype.forEach.call(document.querySelectorAll('table:not([role])'), function (t) {
      if (t.querySelector('th, caption, thead, [scope], [headers]')) return;
      var cells = t.querySelectorAll('td').length; if (!cells) return;
      var rows = t.rows.length, cols = t.rows[0] ? t.rows[0].cells.length : 0;
      var blocks = t.querySelectorAll('td > p, td > div, td > img, td > ul, td > ol, td > h1, td > h2, td > h3, td > h4, td > h5, td > h6, td > figure, td > table').length;
      if (rows <= 1 || cols <= 1 || blocks >= cells / 2) t.setAttribute('role', 'presentation');
    });
  }

  /* 7c. Heading levels must not skip (h2 -> h5): keep the visual style, correct the exposed level */
  function fixHeadingSkips() {
    var prev = 0;
    Array.prototype.forEach.call(document.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]'), function (h) {
      if (!h.getClientRects().length || h.closest('[aria-hidden="true"], [hidden], template')) return;
      var own = parseInt(h.getAttribute('aria-level'), 10) || parseInt(h.tagName.charAt(1), 10) || 2;
      if (prev && own > prev + 1) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', String(prev + 1)); own = prev + 1; }
      prev = own;
    });
  }

  /* 8. Stray ARIA */
  function fixAria() {
    Array.prototype.forEach.call(document.querySelectorAll('[aria-expanded]'), function (el) {
      if (el.getAttribute('role') || /^(BUTTON|SUMMARY|A|INPUT|SELECT|DETAILS|TEXTAREA)$/.test(el.tagName)) return;
      el.removeAttribute('aria-expanded');
    });
    Array.prototype.forEach.call(document.querySelectorAll('div[aria-label], span[aria-label], p[aria-label]'), function (el) {
      if (el.getAttribute('role')) return;
      if (!el.getAttribute('aria-label').trim()) el.removeAttribute('aria-label'); else el.setAttribute('role', 'group');
    });
    Array.prototype.forEach.call(document.querySelectorAll('span[role="separator"][tabindex], div[role="separator"][tabindex]'), function (el) { el.removeAttribute('tabindex'); });
    Array.prototype.forEach.call(document.querySelectorAll('[role="region"][aria-label=""]'), function (el) { el.setAttribute('aria-label', /slideshow|carousel/i.test(el.tagName + el.className + (el.getAttribute('aria-roledescription') || '')) ? 'Slideshow' : 'Section'); });
    /* ids containing spaces (e.g. "link-Meditation Cushions") are not valid IDREFs */
    Array.prototype.forEach.call(document.querySelectorAll('[aria-controls], [aria-labelledby], [aria-describedby], [aria-owns]'), function (el) {
      ['aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns'].forEach(function (attr) {
        var v = el.getAttribute(attr); if (!v || !/\s/.test(v.trim())) return;
        var t = document.getElementById(v) || document.getElementById(v.trim()); if (!t) return;
        var nid = v.trim().replace(/\s+/g, '-'); if (document.getElementById(nid) && document.getElementById(nid) !== t) nid += '-' + (++uid);
        t.id = nid; el.setAttribute(attr, nid);
      });
    });
    /* duplicate ids referenced by aria-controls / aria-labelledby */
    var seen = {};
    Array.prototype.forEach.call(document.querySelectorAll('[id]'), function (el) { seen[el.id] = (seen[el.id] || 0) + 1; });
    Array.prototype.forEach.call(document.querySelectorAll('[aria-controls]'), function (ctl) {
      var id = ctl.getAttribute('aria-controls'); if (!id || seen[id] <= 1) return;
      var all = document.querySelectorAll('[id="' + CSS.escape(id) + '"]');
      var target = null;
      for (var i = 0; i < all.length; i++) { if (ctl.compareDocumentPosition(all[i]) & Node.DOCUMENT_POSITION_FOLLOWING) { target = all[i]; break; } }
      if (!target) return;
      var nid = id + '-' + (++uid); target.id = nid; ctl.setAttribute('aria-controls', nid);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[aria-labelledby]'), function (el) {
      var ids = el.getAttribute('aria-labelledby').split(/\s+/).filter(function (id) { return id && document.getElementById(id); });
      if (ids.length) { if (ids.join(' ') !== el.getAttribute('aria-labelledby')) el.setAttribute('aria-labelledby', ids.join(' ')); }
      else { el.removeAttribute('aria-labelledby'); if (!accName(el) && el.tagName === 'A') el.setAttribute('aria-label', contextHeading(el) || slugToWords(el.getAttribute('href') || '')); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[aria-owns], input[aria-controls], [role="combobox"][aria-owns]'), function (el) {
      ['aria-owns', 'aria-controls'].forEach(function (attr) {
        var v = el.getAttribute(attr); if (!v) return;
        var ok = v.split(/\s+/).filter(function (id) { return document.getElementById(id); });
        if (!ok.length) el.removeAttribute(attr); else if (ok.join(' ') !== v) el.setAttribute(attr, ok.join(' '));
      });
    });
    /* Judge.me medal: visible text must be in the name */
    Array.prototype.forEach.call(document.querySelectorAll('a.jdgm-medal[aria-label]'), function (a) { var t = txt(a); var l = a.getAttribute('aria-label'); if (t && l.toLowerCase().indexOf(t.toLowerCase()) === -1) a.setAttribute('aria-label', t + ' – ' + l); });
    /* Judge.me review pictures: same name, different targets across reviews */
    Array.prototype.forEach.call(document.querySelectorAll('.jdgm-rev'), function (rev) { var who = txt(rev.querySelector('.jdgm-rev__author')) || txt(rev.querySelector('.jdgm-rev__title')); if (!who) return; Array.prototype.forEach.call(rev.querySelectorAll('a[aria-label]'), function (a) { var l = a.getAttribute('aria-label'); if (/picture|image|photo/i.test(l) && l.indexOf(who) === -1) a.setAttribute('aria-label', l + ' – review by ' + who); }); });
    /* nav landmarks need names when there are several */
    var navs = document.querySelectorAll('nav');
    if (navs.length > 1) Array.prototype.forEach.call(navs, function (n, i) { if (n.getAttribute('aria-label') || n.getAttribute('aria-labelledby')) return; var h = n.previousElementSibling && /^H\d|SUMMARY|BUTTON/.test(n.previousElementSibling.tagName) ? txt(n.previousElementSibling).replace(/^(.{2,60}?)\s+\1$/, '$1').slice(0, 60) : ''; n.setAttribute('aria-label', h || (n.closest('footer, .footer, [class*="footer"]') ? 'Footer menu' : n.closest('header, .header') ? 'Main menu' : 'Navigation ' + (i + 1))); });
  }

  /* 9. Horizon: sections paint their colour scheme through an absolutely positioned
     .section-background sibling, which contrast checkers cannot see. Move the plain
     colour onto the section itself (identical rendering). */
  function horizonBackgrounds() {
    if (!CFG.horizonBackgrounds) return;
    Array.prototype.forEach.call(document.querySelectorAll('.section-background'), function (bg) {
      if (bg.__hya) return;
      if (bg.querySelector('img, video, picture, iframe, svg') || getComputedStyle(bg).backgroundImage !== 'none') return;
      var wrap = bg.parentElement; var sec = wrap && wrap.querySelector(':scope > .section, :scope > [class*="section"]:not(.section-background)');
      if (!sec) return;
      var color = getComputedStyle(bg).backgroundColor; if (!color || color === 'rgba(0, 0, 0, 0)') return;
      sec.style.backgroundColor = color; bg.style.backgroundColor = 'transparent'; bg.__hya = true;
    });
  }

  function run() {
    try { normalizeLinks(); } catch (e) {}
    try { fixHrefless(); } catch (e) {}
    try { labelLinks(); } catch (e) {}
    try { dedupeLinks(); } catch (e) {}
    try { fixClickOnly(); } catch (e) {}
    try { fixMedia(); } catch (e) {}
    try { fixForms(); } catch (e) {}
    try { fixLists(); } catch (e) {}
    try { fixTables(); } catch (e) {}
    try { fixHeadingSkips(); } catch (e) {}
    try { fixAria(); } catch (e) {}
    try { horizonBackgrounds(); } catch (e) {}
  }
  function init() {
    run();
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; run(); }, 250); })
      .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['height'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
